import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const LINKS = [
  ["disciplinas", "Disciplinas"],
  ["programa", "Programa"],
  ["trabajo", "Nuestro trabajo"],
  ["actividades", "Actividades"],
  ["mapa", "Mapa interior"],
  ["juegos", "Juegos"],
  ["redes", "Redes"],
  ["galeria", "Galería"],
  ["contacto", "Contacto"],
];

export const Logo = ({ dark = false }) => (
  <img src={dark ? "/brand/logo-horizontal-oscuro.png" : "/brand/logo-horizontal.png"} alt="Once y Once" width="212" height="40" />
);

export const Nav = ({ alwaysSolid = false }) => {
  const [solid, setSolid] = useState(alwaysSolid);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (alwaysSolid) return undefined;
    const onScroll = () => setSolid(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [alwaysSolid]);

  const close = () => setOpen(false);

  return (
    <nav className={"nav" + (solid ? " solid" : "")} aria-label="Principal" data-testid="main-nav">
      <div className="wrap">
        <a className="logo" href="/#inicio" aria-label="Fundación Once y Once" data-testid="nav-logo"><Logo /></a>
        <ul id="menu" className={open ? "open" : ""}>
          {LINKS.map(([id, label]) => (
            <li key={id} className={`nl-${id}`}><a href={`/#${id}`} onClick={close} data-testid={`nav-link-${id}`}>{label}</a></li>
          ))}
          <li><Link to="/equipo" onClick={close} data-testid="nav-link-equipo">Equipo</Link></li>
        </ul>
        <a className="btn btn-sol" href="/#donar" style={{ minHeight: 42 }} data-testid="nav-donar-btn">Donar</a>
        <button className="burger" aria-label="Menú" aria-expanded={open} aria-controls="menu" onClick={() => setOpen((o) => !o)} data-testid="nav-burger-btn">
          <svg width="22" height="22" viewBox="0 0 22 22"><path d="M3 6h16M3 11h16M3 16h16" stroke="#4E4D4D" strokeWidth="2.4" strokeLinecap="round" /></svg>
        </button>
      </div>
    </nav>
  );
};
